export default __webpack_public_path__ + "static/media/rewind-button-icon.3514fcb7.svg";